var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLookupId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m20.458984 2c-1.968315 0.00606-3.921504 0.3441334-5.777343 1h8.318359v3h3v2.2695312c4.289851 2.0973108 7.010041 6.4553728 7.009766 11.2304688 2e-6 6.90356-5.59644 12.500002-12.5 12.5-5.167225 8.6e-5 -9.80191-3.179225-11.6621098-8h-0.8476562v-3h-3v-9.603516c-1.3071129 2.50118-1.9899339 5.281381-1.9902344 8.103516 0 9.664983 7.8350174 17.5 17.5000004 17.5 3.777572-6.98e-4 7.453507-1.223725 10.478515-3.486328l8.253907 8.253906c0.976267 0.976059 2.558889 0.976059 3.535156 0 0.976059-0.976267 0.976059-2.558889 0-3.535156l-8.251953-8.251953c2.262306-3.025787 3.484663-6.702451 3.484375-10.480469 0-9.6649831-7.835017-17.5-17.5-17.5-0.01693-2.46e-5 -0.03385-2.46e-5 -0.05078 0zm-10.458984 3v3h-3v3h3v5h-3v3h3v3h3v-3h5v3h3v-3h3v-3h-3v-5h3v-3h-3v-3h-3v3h-5v-3zm3 6h5v5h-5z",
    style: {
      fillRule: "evenodd",
      fill: "#000000"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookupId);
export default __webpack_public_path__ + "static/media/lookup_id.3dd39a70e8907ab388d2caabfee87c01.svg";
export { ForwardRef as ReactComponent };